import React from "react";
import { useRouteError } from "react-router-dom";

import InlineError from "src/components/Errors/InlineError.tsx";
import PageHeader from "src/components/PageHeader.tsx";
import PageStack from "src/components/PageStack/PageStack.tsx";
import { AuthorizedError } from "src/errors/authorized.error.ts";
import { useT } from "src/internationalization";

const ErrorBoundary: React.FC = () => {
  const error = useRouteError() as { message: string };
  const t = useT();
  // TODO: track in APM

  if (error.message === "NotAuthorized") {
    return (
      <PageStack>
        <div className="flex items-center">
          <PageHeader className="ml-0 mb-5">{(error as AuthorizedError).pageTitle}</PageHeader>
        </div>

        <InlineError
          title={t("component.error.boundary.auth.title")}
          message={t("component.error.boundary.auth.message")}
          type="Warning"
          hideCloseButton
        />
      </PageStack>
    );
  }

  return (
    <InlineError
      title={t("component.error.boundary.title")}
      message={t("component.error.boundary.message")}
    />
  );
};

export default ErrorBoundary;
